import React, { Component } from 'react';
// import ReactDOM from 'react-dom'
import classNames from 'classnames'


import SocialContainer from './Components/react.SocialContainer'; 
import './Assets/Styles/Reset.css';
import './Assets/Styles/App.css';


import Jsmpeg from 'jsmpeg'

import Preload from 'react-preload'
import Loader from './Components/react.loader'

import LandingContainer from './Components/landing'
import CharactersContainer from './Components/charactersContainer'
import SynopsisContainer from './Components/synopsisContainer'
import PartnersContainer from './Components/partnersContainer'
import ReactTransitionGroup from 'react-transition-group/TransitionGroup';

import {TimelineLite} from 'gsap'

var _player = null

class App extends Component {

  constructor() {
    super();

    // this.closeModals = this.closeModals.bind(this)

    let mobileVid = require('./Assets/out2.mpg')
    this.state = {
      logo: [],
      marvelNav: [],
      cta: [],
      activeModal: '',
      loading: true,
      introPlayed: false,
      showCharacters: false,
      showPartners: false,
      showStory: false,
      phone: false,
      showMobileVid: false,
      mobileVid: mobileVid,
      assetLoad: [
        mobileVid,
        require('./Assets/Images/groot_sequence.png'),
        require('./Assets/Images/bg-landing-new.jpg'),
        require('./Assets/Images/heroes.jpg'),
        require('./Assets/Images/logo.png'),
        require('./Assets/Images/cassettes.png')
      ]
    }
  }

  componentWillMount() {
    this.setState({
      logo: {
        label: "Marvel",
        href: "//marvel.com"
      },
      marvelNav: [
        {
          label: "Comics",
          href: "//marvel.com/comics"
        },
        {
          label: "Movies",
          href: "//marvel.com/movies"
        },
        {
          label: "Videos",
          href: "//marvel.com/videos"
        },
        {
          label: "Games",
          href: "//marvel.com/games"
        },
        {
          label: "TV",
          href: "//marvel.com/tv"
        },
        {
          label: "Characters",
          href: "//marvel.com/characters"
        },
        {
          label: "Shop",
          href: "//shop.marvel.com/"
        },
        {
          label: "More",
          href: "#"
        },
      ]
    });
  }

  componentDidMount() {
    let md = new window.MobileDetect(window.navigator.userAgent);

    if(md.phone() !== null){
      this.setState({phone: true})
    }

    // let app = document.querySelector('.App')
    // app.addEventListener('mouseup', this.closeModals)
    
  }

  // closeModals(event) {
  //   if(!(this.state.activeModal === null || this.state.activeModal === '' ) || (this.state.showCharacters || this.state.showPartners || this.state.showStory)){
  //     console.log(event.currentTarget, event.target)
  //   }
  // }

  openModal(target) {
    window.scrollTo(0,0)
    if(target === 'tickets'){
      return;
      
    } else if(target === 'characters'){
      this.setState({
        showCharacters: true,
        introPlayed: true
      })
      return
    } else if(target === 'partners'){
      this.setState({
        showPartners: true,
        introPlayed: true
      })
      return
    } else if(target === 'synopsisModal'){
      this.setState({
        showStory: true,
        introPlayed: true
      })
      return
    }
    this.setState({
      activeModal: target,
      introPlayed: true
    });
  }

  closeModal() {
    this.setState({ activeModal: null })
  }

  loadComplete() {
    // console.log('completed')
  }

  loaderRemoved(){
    let md = new window.MobileDetect(window.navigator.userAgent);
    if(md.phone() !== null){
      this.handleMobileVideo()
    } else {
      // this.setState({showMobileVid: true})
      this.startGrootSequence()
    }
  }

  startGrootSequence(){
    var normalCanvas = document.getElementById('mobile-video');
    normalCanvas.parentNode.removeChild(normalCanvas)

    let groot = document.getElementById('groot-sequence');
    groot.addEventListener(this.animationEnd(), this.showHeroes.bind(this))
    this.setState({loading: false})
  }

  handleMobileVideo() {
    var normalCanvas = document.getElementById('mobile-video');
    _player = new Jsmpeg(this.state.mobileVid, {canvas: normalCanvas, autoplay: false, onload: this.playVideo.bind(this), onfinished: this.vidFinish.bind(this)});
  }

  playVideo(){
    _player.play()
    this.setState({showMobileVid: true})
  }

  vidFinish() {
    // const el = ReactDOM.findDOMNode(this)
    // const content = el.querySelector('.site-content');
    const canvas = document.getElementById('mobile-video');
    var tween = new TimelineLite({ onComplete: this.startGrootSequence.bind(this) })

    tween
    .set(canvas, {
      opacity: 1,
    })
    // .set(el, {
    //   opacity: 1,
    //   scale: 5
    // })
    .to(canvas, 0.8, {
      opacity: 0,
    })
    // .to(content, 0.8, {
    //   opacity: 1,
    // }, '-=.4')

  }

  animationEnd(){
    var t,
        el = document.createElement("fakeelement");

    var animations = {
      "animation"      : "animationend",
      "OAnimation"     : "oAnimationEnd",
      "MozAnimation"   : "animationend",
      "WebkitAnimation": "webkitAnimationEnd"
    }

    for (t in animations){
      if (el.style[t] !== undefined){
        return animations[t];
      }
    }
  }

  showHeroes(){
    this.setState({introPlayed: true})
  }

  closeCharacters() {
    this.setState({
      showCharacters: false
    })
  }

  closeStory() {
    this.setState({
      showStory: false
    })
  }

  closePartners() {
    this.setState({
      showPartners: false
    })
  }

  render() {
    let loadingIndicator = (<Loader loadingText="LOADING" loaderRemoved={this.loaderRemoved.bind(this)}/>)

    let classes = classNames({
      'App': true,
      'loaded': !this.state.loading,
      'completed': this.state.introPlayed,
      'characters-page': this.state.showCharacters,
      'mobile': this.state.phone,
      'show-vid': this.state.showMobileVid
    })

    return (
      <div className={classes}>
        <canvas id="mobile-video"></canvas>
        <Preload loadingIndicator={loadingIndicator} images={this.state.assetLoad} onSuccess={this.loadComplete.bind(this)}>
          <div className="site-content">
            <SocialContainer />


            <ReactTransitionGroup component="div" className="landing-container">
              {!this.state.showCharacters && !this.state.showPartners && !this.state.showStory ?
                <LandingContainer showHeroes={this.state.introPlayed} openModal={this.openModal.bind(this)} activeModal={this.state.activeModal} closeModal={this.closeModal.bind(this)}/>
              : null
            }
            </ReactTransitionGroup>

            <ReactTransitionGroup component="div" className="characters-container">
              {this.state.showCharacters ?
                <CharactersContainer closeCharacters={this.closeCharacters.bind(this)}/>
              : null
              }
            </ReactTransitionGroup>


            <ReactTransitionGroup component="div" className="story-container">
              {this.state.showStory ?
                <SynopsisContainer closeCharacters={this.closeStory.bind(this)}/>
              : null
              }
            </ReactTransitionGroup>

            <ReactTransitionGroup component="div" className="partners-container">
              {this.state.showPartners ?
                <PartnersContainer closePartners={this.closePartners.bind(this)}/>
              : null
              }
            </ReactTransitionGroup>

          </div>
         </Preload> 
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js